import StoreOwnerTreeView from "./StoreOwnerTreeView";
export default StoreOwnerTreeView;
